<template>
<v-layout fluid style="width: 100%;" class="pa-0 d-flex flex-row" fill-height wrap lights-out>
    <v-col cols="12" sm="12" lg="3"  :style="{'background-color': color}">
        <v-row class="ma-0">
			<v-col cols="auto" class="pa-0">
				<slot name="breadcrumbs" :item="true"></slot>
			</v-col>
            <v-spacer/>
            <!-- export -->
			<v-col cols="auto" class="pa-0">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('MaterialsTreePage.export')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="tree"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel')"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="tree"
							:item="exportItems[1]"
							dense
							@click="exportAs('pdf')"
						></bee-list-item>
					</bee-list>
				</v-menu>
			</v-col>
        </v-row>
        <v-row>
            <v-col cols="auto" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <bee-autocomplete 
					:item-text="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_name' : 'name'"
					:item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
					:label="$t('MaterialsTreePage.warehouse')"
					:items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
					v-model="warehouse"
					:clearable="false"
					:hide-details="true"
					context="warehouse"
					:action-name="actions.GET"
					@change="materials_tree = []"
			></bee-autocomplete>
            </v-col>
        </v-row>
        <v-row fill-height>
			<v-main style="width: 100%" class="px-3 pt-0" color="greyLighten5">
				<!-- <bee-treeview
				    v-if="renderComponent"
				    @update:active="Update($event)"
				    :filter-hint="$t('MaterialsTreePage.material-name-or-no')"
				    :lables-values="['inner_no', 'name']"
				    :items="materials_tree"
				>
                    <template v-slot:actions="{}">
                        <bee-btn
                        @click="create()"
                        :disabled="file_is_locked"
                        color="addingColor"
                        context="material"
                        :action-name="actions.CREATE">
                            <template v-slot:content="" >
                                <v-img width="25" contain :src="require('../../../assets/add-product.png')" class="mx-1"></v-img>
                                {{$t('MaterialsTreePage.add')}}
                            </template>
                        </bee-btn>
                    </template>
                </bee-treeview> -->
				<v-row class="pb-2">
					<v-col cols="8" class="px-1">
						<v-autocomplete
							v-model="materialId"
							class="text-subtitle-2"
							:items="materials"
							outlined
							hide-no-data
							:loading="materialsLoading"
							dense
							clearable
							:label="$t('MaterialsTreePage.material-name-or-no')"
							hide-details
							item-value="id"
							:item-text="item => item.inner_no + '-' + item.name"
							@change="materialsTreeFilterActivate(materialId)"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="4" class="d-flex justify-end align-center">
						<bee-btn
							:disabled="file_is_locked || ( $route.params.id &&  materials.find(v => v.id === Number($route.params.id))?.type === type.sub)"
							color="addingColor"
							:content="$t('AccountsTreePage.add')"
							icon="fa-plus"
							context="material"
							:action-name="actions.CREATE"
							@click="create()"
						></bee-btn>
					</v-col>
				</v-row>
				<div @contextmenu.prevent>
					<v-treeview
						id="tree-view"
						:open.sync="openedNodes"
						:active.sync="activeMaterials"
						:style="`overflowY:auto;height:${$vuetify.breakpoint.height - 240 + 'px'}`"
						:items="materials_tree"
						activatable
						item-text=""
						transition
						dense
						selected-color="primary"
						return-object
						hoverable
						@update:active="Update($event)"
					>
						<template v-slot:prepend="{item}">
							<v-icon 
								v-if="item.children ? item.children.length > 0 : false"
								class="me-1"
								small 
								color="#d9bd5d"
								@click.stop="openNodes(item)"
							>
								{{openedNodes.find(v => v === item) ? 'fa-minus' : 'fa-plus'}}
							</v-icon>
							<div v-else class="px-1"></div>
						</template>
						<template v-slot:label="{item}">
							<div
								@contextmenu.prevent="initContextMenu($event, item)"
							>
								<p :ref="'material-'+ item.id" class="ma-0 text-subtitle-2" :class="{'deletingColor--text':item.type === 1}">
									{{
										item.inner_no + '-' + item.name
									}}
								</p>
							</div>
						</template>
					</v-treeview>
				</div>
				<!-- context menu -->
				<v-menu
					v-model="contextMenuData.show"
					:position-x="contextMenuData.x"
					:position-y="contextMenuData.y"
					absolute
					offset-y
				>
					<v-list dense>
						<v-list-item
							v-for="(item, index) in contextMenuItems"
							:key="index"
							:disabled="typeof item.disabled === 'function' ? item.disabled(contextMenuData.node) : Boolean(item.disabled)"
							@click="item.action(contextMenuData.node)"
						>
							<v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-main>
        </v-row>
    </v-col>

    <v-col cols="auto" sm="12" lg="9">
		<div :style="{maxHeight: $vuetify.breakpoint.height - 90 + 'px', overflowY: 'auto'}">
			<v-scroll-y-transition mode="out-in">
				<v-card flat style="height: 80vh" v-if="!selected" class="d-flex flex-column justify-content-center justify-center">
				<v-card-text>
				<v-img
						left
						class="shrink"
						contain
						:src="require('../../../assets/choose-material.png')"
						transition="scale-transition"
						height="200"
					/>
				</v-card-text>
				<v-card-title class="align-center justify-center">
					<span style="align-self: center;" class="blue-grey--text text--lighten-1 font-weight-light">
						{{$t('MaterialsTreePage.please-select-material')}}
					</span>
				</v-card-title> 
				</v-card>
				
				<router-view
					v-else
					@reload-materials-tree="(childAction) => { 
						this.fetchMaterials().then(() => {childAction()})
					}" 
				/>
			</v-scroll-y-transition>
		</div>
	</v-col>
</v-layout>
</template>
<script>
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension';
import { userType, type } from '@/helpers/enums';
import { multipleWarehouses } from '@/configs/global'
export default {
data: () => ({
	actions,
	renderComponent: true,
    selected: false,
    node: {id: null},
	userType,
	type,
	materials_tree: [],
	materials: [],
	multipleWarehouses,
	openedNodes: [],
	lastOpenedNodes: [],
	activeMaterials: [],
	materialId: null,
	materialsLoading: false,
	contextMenuData: {
		x: 0,
		y: 0,
		node: null,
		show: false
	}
  }),
watch: {
	$route(to) {
		this.selected = !(this.$route.name == "materials-tree")
		if (to.params.id) {
			this.materialsTreeFilterActivate(to.params.id)
		}
	},
},
methods: {
	create() {
        this.node.id  && this.selected
			? this.$router.push({ name: "add-material", params: { parentId: this.node.id } }).catch(()=>{}) 
			: this.$router.push({ name: "create-material" }).catch(()=>{})
    },
    Update(items) {
        this.selected = true;
		const item = Array.isArray(items) ? items[0] : items;

		if(item)
		{
			if(!(this.$route.name === 'update-material' && this.$route.params.id === item.id)) {
				this.$router.push({ name: "show-material", params: { id: item.id } }).catch(()=>{})
				this.node = item
			}
		}
		else{
			this.$router.push({ name: "materials-tree"}).catch(()=>{})
            this.node = {id: null}
		}	
    },
	fetchMaterials(){
		this.materialsLoading = true;
		return store.dispatch('materials/fetchTree',  Number(this.$route.params.warehouseId)).then((data) => {
			this.materials_tree = data
			// this.renderComponent = true;
			this.materials_tree.forEach(materials => {
				this.convertTreeToArray(materials);
			})
			this.materialsTreeFilterActivate(Number(this.$route.params.id));
			this.materialsLoading = false;
			// store.dispatch('materials/fetchWarehouseMaterials', Number(this.$route.params.warehouseId))
		})
    },
	openNodes(item) {
		const index =this.openedNodes.findIndex(t => t.id === item.id)
		if(index !==-1) {
			this.openedNodes.splice(index, 1);
		} else {
			this.openedNodes.push(item)
		}
	},
	initContextMenu(e, item) {
		this.contextMenuData.x = e.clientX;
		this.contextMenuData.y = e.clientY;
		this.contextMenuData.node = item;
		this.$nextTick(() => {
			this.contextMenuData.show = true
		})

	},
	materialsTreeFilterActivate(materialId) {
		if(materialId) {
			this.activeMaterials = [];
			// this.openedNodes = [];
			const material = this.materials.find(v => v.id === materialId);
			this.activeMaterials.push(material);
			if(material?.parent_id) {
				this.materialsTreeFilterNodesOpen(material.parent_id);
			}
			this.$nextTick(() => {
				setTimeout(() =>{
					const el = this.$refs['material-' + materialId];
					if (el) {
						el.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				})
			})

			
		}
	},
	materialsTreeFilterNodesOpen(materialId) {
		const material = this.materials.find(v => v.id == materialId);
		if (this.openedNodes.findIndex(v => v.id === material.id) === -1) {
			this.openedNodes.push(material);
		}
		if(material.parent_id) {
			this.materialsTreeFilterNodesOpen(material.parent_id);
		}
	},
	convertTreeToArray(item, path, index) {
		if (path) {
			item.path = [...path, index]
		} else if(index){
			item.path = [index];
		} else {
			item.path = [];
		}
		this.materials.push(item);
		if(item.children)
		{
			item.children.forEach((v, i) => {
				this.convertTreeToArray(v, item.path, i)
			})
		}

	},
    exportAs(type) {
        this.$store.dispatch('reports/MaterialsTreeReport', {
            type,
            financialFileId: this.configs.financial_file.id,
			userId: ls.getLocalUser().id,
            warehouseId: Number(this.$route.params.warehouseId)
        })
    },
	// editNode() {
	// 	const node = this.materials.find(v => v.id === Number(this.$route.params.id));
	// 	let index = 1;
	// 	let material = this.materials[node.path[0]];
	// 	while(index < node.path.length ) {
	// 		material = material.children[index++];
	// 	}
	// 	material = node;
	// }
},
computed: {
    ...mapState("configs", ["configs"]),
    ...mapState("warehouses" , ["warehouses"]),
	...mapState({
		userTypePermission: state => state.permissions.user_type,
		// warehousesForKeeper: state => state.warehouses.warehousesForKeeper
		warehousesForKeeper: state => state.permissions.warehousesForKeeper,
		isAdvancedAccountant: state => state.permissions.isAdvancedAccountant
	}),
    exportItems() {
		return [
			{
				text: this.$t('MaterialsTreePage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('MaterialsTreePage.print-materials-tree'),
				icon: 'mdi-printer',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},
    file_is_locked(){
        return this.configs?.financial_file?.is_locked },
    color() {
      return this.$vuetify.theme.themes.light.greyLighten5;
	},
    warehouse:{
        get: function(){
            return Number(this.$route.params.warehouseId)
        },
        set: function (value) {
            if(Number(value))
                this.$router.push({ name: "materials-tree", params: { warehouseId: value} })
                            .then(()=>this.fetchMaterials())
                            .catch(()=>{})
        }
    },
	contextMenuItems() {
		return [
			{ 
				title: this.$t('buttons.add-child-material'), 
				event: 'add-child', 
				disabled: item => item?.type === type.sub, 
				action: item => {
					this.$route.params.parentId !== item.id
					? this.$router.push({ name: 'add-material', params: { parentId: item.id } })
					: null
				} 
			},
			!this.isAdvancedAccountant ? { 
				title: this.$t('buttons.material-statement'), 
				event: 'account-statement' ,
				action: item => {
					this.$router.push({ name: 'material-statment', query: { id: item.id }})
				}
			} : null,
			{ 
				title: this.$t('buttons.edit'), 
				event: 'edit',
				action: item => {
					this.$router.push({name: 'update-material', params: {id: item.id}})
				}
			},
		].filter(Boolean)
	},

},
mounted(){
    if(this.$route.params.warehouseId)
        this.fetchMaterials()
},
async beforeRouteEnter(to, from, next) {
    let promises = [store.dispatch('warehouses/fetchAll'), store.dispatch('unitSizes/fetchAll')]
    let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	await Promise.all(promises)

    next(vm => {
		to.name == "materials-tree" ? vm.selected = false : vm.selected = true
    })
},
meta: {
		title: 'accounts-tree',
		meta: [
			{property: 'og:title', content: 'materials-tree / mirta'},
		],
	},
};
</script>
<style lang="scss" scoped>
#tree-view{
	.v-treeview-node__toggle{
		display: none;
	}
	cursor: pointer;
}
</style>